import { Amplify } from "aws-amplify";
import awsExports from "../aws-exports";

export const API_URL = awsExports.apiUrl || process.env.REACT_APP_API_URL || "";

export function configureAmplify() {
  const userPoolId = awsExports.userPoolId || "";
  const userPoolClientId = awsExports.userPoolClientId || "";

  if (!userPoolId || !userPoolClientId) {
    console.error("[GEM] Cognito not configured — check aws-exports.js");
    return;
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: { email: true },
      },
    },
  });
}
